(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/common/assets/javascripts/rejected-player.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/common/assets/javascripts/rejected-player.js');
"use strict";


const _React = React,
  useRef = _React.useRef;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const fetchPlayerCompetitions = svs.components.marketplaceCompetition.services.actions.playerCompetitionActions.fetchPlayerCompetitions;
const ReactButton = svs.ui.ReactButton;
const RejectedPlayer = _ref => {
  let InnerComponent = _ref.InnerComponent,
    _ref$activeOnly = _ref.activeOnly,
    activeOnly = _ref$activeOnly === void 0 ? false : _ref$activeOnly,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'För tillfället går det inte att visa någon information om tävlingen.' : _ref$text;
  const dispatch = useDispatch();
  const debounce = useRef(_.debounce(() => {
    dispatch(fetchPlayerCompetitions({
      forceFetch: true,
      isActiveOnly: activeOnly
    }));
  }, 1000));
  const handleClick = () => {
    debounce.current();
  };
  return React.createElement(InnerComponent, {
    className: "my-bets-competition-rejected"
  }, React.createElement("p", {
    className: "f-700 fc-navy"
  }, text), React.createElement(ReactButton, {
    block: true,
    onClick: handleClick,
    transparent: true
  }, "F\xF6rs\xF6k igen"));
};

setGlobal('svs.components.marketplaceCompetition.common', {
  RejectedPlayer
});

 })(window);